module.exports = __webpack_public_path__ + "static/media/91WzO6167wL._AC_UX679_.04dedc05.jpg";